import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List } from 'immutable';
import classNames from 'classnames';
import uniqueId from 'src/utils/uniqueId';

import LoadAnimation from '../../decorators/LoadAnimation';
import Button from '../../helpers/Button';

import { CompanyBuyer } from './CompanyBuyer';

import style from './style.module.css';

/**
 * Company buyers' list component.
 *
 * @param props {Object}.
 * @param props.buyers {Immutable.List} Buyer definition.
 * @param props.onClick {Function} On buyer's click callback.
 * @param props.addBuyer {Function} On add Buyer click callback.
 * @returns {XML}
 * @class
 */
const CompanyBuyersComponent = LoadAnimation(
  ({
    buyers,
    id = uniqueId(),
    onActivate,
    addBuyer,
    onDelete,
    onClick,
    suggestApprovalList,
    onChangeApprove,
    suggestProject,
    statuses,
    onUpdateHighStatus,
    canEditData,
  }) => {
    const buyersContent = buyers.map((buyer, i) => (
      <CompanyBuyer
        key={buyer.get('id')}
        buyer={buyer}
        canEditData={canEditData}
        isFirst={i === 0}
        onActivate={event => onActivate(event, i)}
        onChangeApprove={(...rest) => onChangeApprove(...rest, i)}
        onClick={event => onClick(event, i)}
        onDelete={onDelete}
        onUpdateHighStatus={onUpdateHighStatus}
        parentId={id}
        prefix={`buyers.${i}`}
        statuses={statuses}
        suggestApprovalList={suggestApprovalList}
        suggestProject={suggestProject}
      />
    ));

    return (
      <div className={classNames(style.host, 'accordion-right-side mt0')} id={id}>
        <p className="mb0"> Buyers </p>
        <form>{buyersContent}</form>

        <div className="clearfix" />
        <Button className="btn-primary btn-block" onClick={addBuyer}>
          + Add new buyer...
        </Button>
      </div>
    );
  },
);

CompanyBuyersComponent.propTypes = {
  addBuyer: PropTypes.func.isRequired,
  buyers: PropTypes.instanceOf(List).isRequired,
  id: PropTypes.string,
  onActivate: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

/** Company buyers component. */
export const CompanyBuyers = memo(CompanyBuyersComponent);
